import { uniqueId } from "lodash";
import { BaseAction } from ".";
import { ToastInfo, ToastTypes } from "../../shared/models/toast";

export enum ToasterActions {
    AddToast = '[Toast] Add new toast',
    RemoveToast = '[Toast] Remove toast'
}

export class CreateInfoNotice implements BaseAction<ToasterActions> {
    readonly type = ToasterActions.AddToast;

    public readonly payload: ToastInfo;

    constructor(title: string, body: string) {
        this.payload = {
            id: uniqueId(),
            type: ToastTypes.Info,
            title,
            body,
        };
    }
}

export class CreateSuccessNotice implements BaseAction<ToasterActions> {
    readonly type = ToasterActions.AddToast;

    public readonly payload: ToastInfo;

    constructor(title: string, body: string) {
        this.payload = {
            id: uniqueId(),
            type: ToastTypes.Success,
            title,
            body,
        };
    }
}

export class CreateErrorNotice implements BaseAction<ToasterActions> {
    readonly type = ToasterActions.AddToast;

    public readonly payload: ToastInfo;

    constructor(title: string, body: string) {
        this.payload = {
            id: uniqueId(),
            type: ToastTypes.Error,
            title,
            body,
        };
    }
}

export class RemoveToast implements BaseAction<ToasterActions> {
    readonly type = ToasterActions.RemoveToast;

    constructor(public readonly id: string) { }
}

export type ToasterAction = CreateInfoNotice | CreateSuccessNotice | CreateErrorNotice | RemoveToast;
